import React, {
  SyntheticEvent,
  useContext,
} from 'react';
import IconButton from '@mui/material/IconButton';
import clsx from 'clsx';
import DeleteIcon from 'core/icons/delete';
import ToolTip from 'core/components/Tooltip';
import {
  ConfirmationDialogContext,
} from 'pages/Dashboard/contexts/confirmationDialog';
import {
  useUpdateToDoHandler,
} from 'pages/Dashboard/pages/Todos/hooks';
import {
  ToDo,
} from 'types/toDo';

type Props = {
  toDo?: ToDo;
};

type DeleteToDoContentProps = {
  name?: string;
};

function DeleteToDoContent({ name }: DeleteToDoContentProps) {
  return (
    <div>
      Are you sure you want to abandon
      <br />
      <strong>{name}</strong>
      ?
    </div>
  );
}

export default function AbandonButton({ toDo }: Props) {
  const { openDialog, closeDialog } = useContext(ConfirmationDialogContext);
  const { asyncHandler: updateToDo } = useUpdateToDoHandler({
    successMessage: `"${toDo?.name}" was abandoned.`,
  });

  const handleDelete = (event: SyntheticEvent) => {
    event.stopPropagation();
    openDialog({
      content: <DeleteToDoContent name={toDo?.name ?? undefined} />,
      onConfirm: async () => {
        await updateToDo({
          toDoId: toDo?.toDoId,
          transitionName: 'Abandon',
          dueDate: toDo?.dueDate ?? null,
        });
        closeDialog();
      },
      title: 'Abandon To-Do',
      confirmText: 'Abandon',
    });
  };

  return (
    <ToolTip
      title={toDo?.isAbandoned ? 'To-do is already abandoned' : 'Abandon'}
    >
      <span>
        <IconButton
          className={clsx(
            { '!cursor-not-allowed !pointer-events-auto !opacity-50': toDo?.isAbandoned },
          )}
          disabled={toDo?.isAbandoned}
          aria-label="Abandon To-Do"
          size="small"
          onClick={handleDelete}
        >
          <DeleteIcon className="!text-xl text-black" />
        </IconButton>
      </span>
    </ToolTip>
  );
}
